var isWebColor = function isWebColor(color) {
  return color === 'currentcolor' || color === 'currentColor' || color === 'inherit' || color.indexOf('var(') === 0;
};

export default isWebColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-native-web/dist/modules/isWebColor/index.js
// module id = 163
// module chunks = 0